<section id="profile-info">
                <div class="row">
                    <div class="col-lg-12 col-12 order-1 order-lg-2">
                        <div class="form-group mb-2">
                            <div class="card">
                                <div class="card-header">
                                    <h2>Fee Details</h2>
                                </div>
                                <div class="card-body">
                                    <quill-editor class="university-info" [(ngModel)]="data"
                                                  name="quill-content"></quill-editor>
                                </div>
                                <div class="card-footer">
                                    <button class="btn btn-primary pull-right" rippleEffect (click)="submit()">
                                        <i data-feather="submit" class="d-block d-md-none"></i>
                                        <span class="font-weight-bold d-none d-md-block">Submit</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 col-12">
                        <div class="card">
                            <div class="card-header">
                                <h2>Fees Table</h2>
                            </div>
                            <div class="card-body">
                                <table class="table table-list">
                                    <thead>
                                    <tr>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Course</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Duration</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Course Fee</h6>
                                        </th>
                                        <th class="text-center">
                                            <h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody *ngIf="pcbMappings && pcbMappings.length > 0; else noDataToShowWeb">
                                    <tr *ngFor="let pcbMapping of pcbMappings; let i = index">
                                        <td class="text-center">
                                            <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                                .</h6>
                                        </td>
                                        <td class="text-center">
                                            {{pcbMapping?.course?.name}}
                                        </td>
                                        <td class="text-center">
                                            {{pcbMapping?.course_curriculum?.duration || '-'}}
                                        </td>
                                        <td class="text-center">
                                            {{pcbMapping?.course_curriculum?.course_fee || '-'}}
                                        </td>
                                        <td class="text-center">
                                            <i aria-hidden="true"
                                               class="fab fa-artstation f_20 text-primary ml-5px cursor-pointer font-weight-light mt-1"
                                               title="Perform Actions" (click)="courseCurriculum(pcbMapping)"></i>
                                        </td>
                                    </tr>
                                    </tbody>
                                    <ng-template #noDataToShowWeb>
                                        <tbody>
                                        <tr>
                                            <td colspan="5" class="text-center">
                                                <h6>No data to show</h6>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </ng-template>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
